/* ------------ Persist Entire Query String for HubSpot Forms ------------ */

(function () {
  console.log("UTM script loading. Source:", document.currentScript ? document.currentScript.src : "unknown");

  const TTL_DAYS = 90;
  const STORAGE_KEY = "query_data";

  // Helper to get full query string from URL
  function getQueryString() {
    const queryString = window.location.search;
    return queryString ? queryString.substring(1) : ''; // Remove leading '?'
  }

  // Store query string in localStorage with expiry
  function saveQueryToLocalStorage(queryString) {
    if (!queryString) {
      console.log("No query string to store");
      return;
    }
    const expiry = Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000; // 90 days
    const data = { query: queryString, expiry };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      console.log("Stored in localStorage:", STORAGE_KEY, data);
    } catch (e) {
      console.error("Failed to store in localStorage:", e);
    }
  }

  // Load stored query string if not expired
  function loadQueryFromLocalStorage() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const { query, expiry } = JSON.parse(stored);
        if (Date.now() < expiry) {
          console.log("Retrieved from localStorage:", STORAGE_KEY, query);
          return query;
        } else {
          localStorage.removeItem(STORAGE_KEY);
          console.log("Removed expired querylag in localStorage:", STORAGE_KEY);
        }
      }
    } catch (e) {
      console.error("Failed to read localStorage:", e);
    }
    return null;
  }

  // Check if page has a HubSpot form
  function pageContainsHbsptForm() {
    const hasForm = document.querySelector('iframe[src*="hsforms.net"]') !== null;
    console.log("HubSpot form present:", hasForm);
    return hasForm;
  }

  // Append query string to current URL without reload
  function populateQueryInURL() {
    const currentQuery = getQueryString();
    let queryToUse = null;

    // Prioritize new query string and update storage
    if (currentQuery) {
      saveQueryToLocalStorage(currentQuery);
      queryToUse = currentQuery;
      console.log("Using new query string from URL:", queryToUse);
    } else {
      queryToUse = loadQueryFromLocalStorage();
      console.log("Using stored query string:", queryToUse || "none");
    }

    if (queryToUse && pageContainsHbsptForm()) {
      try {
        const url = new URL(window.location.href);
        if (!url.search) { // Only append if no query string exists
          url.search = queryToUse;
          window.history.replaceState({}, '', url.toString());
          console.log("Appended query string to URL:", url.toString());
        } else {
          console.log("URL already has query string, skipping append:", url.search);
        }
      } catch (e) {
        console.error("Failed to update URL:", e);
      }
    } else {
      console.log("No action: Form not present or no query to use");
    }
  }

  // Observe DOM changes for dynamically added HubSpot forms
  function observeForms() {
    try {
      const observer = new MutationObserver(function (mutations) {
        let formAdded = false;
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.tagName === 'IFRAME' && node.src && node.src.includes('hsforms.net')) {
              formAdded = true;
              console.log("HubSpot form detected in DOM:", node);
            }
          });
        });
        if (formAdded) {
          console.log("Triggering query string append for new form");
          populateQueryInURL();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      console.log("Started observing DOM for HubSpot form changes");
    } catch (e) {
      console.error("Failed to set up MutationObserver:", e);
    }
  }

  // Fallback to check for forms periodically
  function startPeriodicFormCheck() {
    const maxAttempts = 10;
    let attempts = 0;
    const interval = setInterval(() => {
      if (pageContainsHbsptForm()) {
        console.log("Form detected via periodic check");
        populateQueryInURL();
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        console.log("Stopped periodic form check: max attempts reached");
        clearInterval(interval);
      }
      attempts++;
    }, 1000); // Check every 1 second
  }

  // Initialize
  try {
    const currentQuery = getQueryString();
    if (currentQuery) {
      saveQueryToLocalStorage(currentQuery); // Store new query string if present
    }
    populateQueryInURL(); // Check immediately
    observeForms(); // Start observing for dynamic forms
    startPeriodicFormCheck(); // Fallback for late-loaded forms
  } catch (e) {
    console.error("Initialization failed:", e);
  }
})();